import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@mafc/trolly';

import { isExpressShipment } from 'pages/NewCart/helpers/shipment.helper';
import * as S from './ShipmentItemHeader.style';

const ShipmentItemHeader = ({
  shipmentNumber,
  shipmentType,
  shopName,
  totalShipments,
  totalShipmentItems,
}: {
  shipmentNumber: number;
  shipmentType: string;
  shopName: string;
  totalShipments: number;
  totalShipmentItems: number;
}) => {
  const { t } = useTranslation();

  let shipmentTitle = null;
  if (totalShipments > 1) {
    shipmentTitle = t('cartShipment.shipmentNumber', {
      shipmentNumber,
      totalShipments,
    });
  } else if (isExpressShipment(shipmentType)) {
    shipmentTitle = t('cartShipment.yourNowShipment');
  } else {
    shipmentTitle = t('cartShipment.shipment');
  }

  return (
    <S.ShipmentItemHeader>
      <S.ShipmentStats>
        <S.ShipmentNumber>{shipmentTitle}</S.ShipmentNumber>

        <Text as="span">
          {totalShipmentItems} {totalShipmentItems > 1 ? t('items.plural') : t('items.single')}
        </Text>
      </S.ShipmentStats>
      <S.SoldBy>
        {t('fbc.soldBy', {
          shopName,
        })}
      </S.SoldBy>
    </S.ShipmentItemHeader>
  );
};

export default ShipmentItemHeader;
